module.exports = __webpack_public_path__ + "img/cb-grid.9f10d741.svg";